// Runtime Configuration Helper
// Build sonrası config.js dosyası değiştirilerek URL'ler güncellenebilir

interface AppConfig {
  ADMIN_API_URL: string;
  COMPANY_API_URL: string;
  API_URL: string;
  TRANSLATE_API_URL: string;
}

declare global {
  interface Window {
    __APP_CONFIG__?: AppConfig;
  }
}

// Öncelik: window.__APP_CONFIG__ > import.meta.env > fallback
export function getConfig(): AppConfig {
  const windowConfig = window.__APP_CONFIG__;
  
  return {
    ADMIN_API_URL: windowConfig?.ADMIN_API_URL || import.meta.env.VITE_ADMIN_API_URL || '/admin-api',
    COMPANY_API_URL: windowConfig?.COMPANY_API_URL || import.meta.env.VITE_COMPANY_API_URL || '/api',
    API_URL: windowConfig?.API_URL || import.meta.env.VITE_API_URL || '/api',
    TRANSLATE_API_URL: windowConfig?.TRANSLATE_API_URL || import.meta.env.VITE_TRANSLATE_API_URL || 'https://translate.passqr.com.tr/api'
  };
}

// Tek tek erişim için
export const config = {
  get adminApiUrl(): string {
    return getConfig().ADMIN_API_URL;
  },
  get companyApiUrl(): string {
    return getConfig().COMPANY_API_URL;
  },
  get apiUrl(): string {
    return getConfig().API_URL;
  },
  get translateApiUrl(): string {
    return getConfig().TRANSLATE_API_URL;
  }
};
